import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router";
import { useAppSelector } from "../store/hooks";
import { Spin } from "antd";

const HomePage = lazy(() => import('./home'));
const LoginPage = lazy(() => import('./login/LoginPage'));
const Signup = lazy(() => import('./signup'));
const ProtectedRoute = lazy(() => import('../components/ProtectedRoute'));
const PageNotFound = lazy(() => import('./not-found/PageNotFound'));
const ForgotPage = lazy(() => import('./forgot'));
const PrivacyPage = lazy(() => import('./legalPages/privacy'));
const ProhibitedPage = lazy(() => import('./legalPages/prohibited'));
const TermsPage = lazy(() => import('./legalPages/terms'));
const PostPage = lazy(() => import('./post'));
const AccountProfile = lazy(() => import('./account/profile'));
const AddPost = lazy(() => import('./add-post'));
const OurStory = lazy(() => import('./our-story'));
const SupportPage = lazy(() => import('./support'));
const BillingPage = lazy(() => import("./billing"));
const SavedPage = lazy(() => import("./saved"));
const MyListingPage = lazy(() => import("./my-listing"));
const SecurityPage = lazy(() => import("./security"));
const CategoriesPage = lazy(() => import("./categories"));
const FeaturedPostsPage = lazy(() => import("./featured-posts"));
const SellerPostPage = lazy(() => import("./seller-post"));
const RecentActivity = lazy(() => import("./recent-activity"));

const Router = () => {
  const { token, user } = useAppSelector((state) => state.auth);
  const authenticatedUser = Boolean(token && user);
  return (
    <Suspense
      fallback={
        <div className='h-screen w-screen flex items-center justify-center'>
          <Spin size='large' />
        </div>
      }
    >
      <Routes>
        <Route index element={<HomePage />} />
        <Route path="post/:postId" element={<PostPage />} />
        <Route path="privacy" element={<PrivacyPage />} />
        <Route path="terms" element={<TermsPage />} />
        <Route path="prohibited" element={<ProhibitedPage />} />
        <Route path="story" element={<OurStory />} />
        <Route path="support" element={<SupportPage />} />
        <Route path="categories" element={<CategoriesPage />} />
        <Route path='category/:categoryId' element={<CategoriesPage />} />
        <Route path='featured-posts' element={<FeaturedPostsPage />} />
        <Route path="seller-post/:sellerId" element={<SellerPostPage />} />
        <Route element={<ProtectedRoute isAllowed={!authenticatedUser} />}>
          <Route path="login" element={<LoginPage />} />
          <Route path="signup" element={<Signup />} />
          <Route path="forgot" element={<ForgotPage />} />
        </Route>
        <Route element={<ProtectedRoute isAllowed={authenticatedUser} />}>
          <Route path="account/my-listing" element={<MyListingPage />} />
          <Route path="account/profile" element={<AccountProfile />} />
          <Route path="account/billing" element={<BillingPage />} />
          <Route path="account/saved-posts" element={<SavedPage />} />
          <Route path="account/security" element={<SecurityPage />} />
          <Route path="post/add" element={<AddPost />} />
          <Route path="post/edit/:postId" element={<AddPost />} />
          <Route path="account/activity" element={<RecentActivity />} />
        </Route>
        <Route path='*' element={<PageNotFound />} />
      </Routes>
    </Suspense>
  );
};

export default Router;
